/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

"use client";

import { getPublicSiteUrl } from "@cosmos/common-utils";
import { createContext, useContext } from "react";

import type { ReactNode } from "react";

interface ApiConfig {
	serverUrl?: string;
	authPath?: string;
}

const ApiConfigContext = createContext<ApiConfig>({});

export interface ApiConfigProviderProps {
	serverUrl?: string;
	basePath?: string;
	authPath?: string;
	children: ReactNode;
}

export function ApiConfigProvider({
	serverUrl,
	basePath,
	authPath,
	children,
}: ApiConfigProviderProps): React.JSX.Element {
	const mountedServerUrl = basePath === undefined ? serverUrl : getPublicSiteUrl(serverUrl, basePath);

	return (
		<ApiConfigContext.Provider value={{ serverUrl: mountedServerUrl, authPath }}>{children}</ApiConfigContext.Provider>
	);
}

export function useApiConfig(): ApiConfig {
	return useContext(ApiConfigContext);
}
